module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-layout"
  }, [_c('div', {
    staticClass: "layout-container"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.footerVisible) ? _c('div', {
    staticClass: "zk-footer-wrap"
  }, [_c('zk-footer')], 1) : _vm._e(), _vm._v(" "), _c('zk-back-top')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60a90c5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./pc/yiqijian-video/components/Layout/index.vue
// module id = 52
// module chunks = 1 2 3 4 5